import { createShapeNormalizer, normalizeBoolean } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const normalizeBooleanRecordShape = createShapeNormalizer({
	type: 'record',
	shape: { type: 'boolean' },
});

/**
 * expected format:
 * - boolean
 * - json: { "default": true, "route-id": false, "other-route-id": false }
 */
export const FCM_CORGI_SSR_CACHE = defineFcm('corgi_ssr_cache')
	.asJson((value: unknown) => {
		try {
			return {
				default: normalizeBoolean(value),
				overrides: {},
			};
		} catch (e) {
			const objectValue = normalizeBooleanRecordShape(value);
			return {
				default: !!objectValue.default,
				overrides: Object.entries(objectValue)
					.filter(([name]) => name !== 'default')
					.reduce(
						(acc, [name, val]) => ({
							...acc,
							[name]: val,
						}),
						{},
					),
			};
		}
	})
	.withDefault({ default: false, overrides: {} })
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'corgi SSR',
		description: `Used to enable corgi SSR server caching.
			"default" is used to indicate that server caching should be enabled by default on routes that support it.
			Other properties should match the route's id in corgi, and are used to override that default behavior.`,
		import: false,
		template: {
			default: true,
			'route-id': false,
		},
	});
